import { SectionCard } from '@/components/common/SectionCard';
import { RENEWAL_STRINGS as T } from '@/lib/constants/renewal-strings';
import { formatDate } from '@/lib/utils/date.utils';

export interface RenewalScheduledCardProps {
  planName: string;
  /** When the SR NEXT package ends, which is when the subscription starts. */
  startsAt: string;
}

/** A data room renewal bought during the SR NEXT package, waiting for its start (MYN-247, FR-297). */
export function RenewalScheduledCard({ planName, startsAt }: RenewalScheduledCardProps) {
  return (
    <SectionCard title={T.SCHEDULED_TITLE}>
      <p className="text-text-secondary text-sm">
        {T.SCHEDULED_BODY(planName, formatDate(startsAt))}
      </p>
    </SectionCard>
  );
}
